// ENUMS

export enum EnergyType {
  BIO = 'Bio Energy',
  WATER = 'Water',
  WIND = 'Wind',
  ZON = 'Solar'
}

export enum State {
  AVAILABLE = 'Available',
  SOLD_OUT = 'Sold Out',
  RESERVED = 'Reserved'
}

// TYPES

type Address = {
  address: string
  lat: string
  lng: string
}

export type APIProducer = {
  id: string
  enabled: boolean
  salesforceId: string
  isFeatured: {
    nl: boolean
    fr: boolean
  }
  isPopular: {
    nl: boolean
    fr: boolean
  }
  isSoldOut: boolean
  location: string
  state: State
  energyType: string
  energyRegion: string
  energyUsed: number
  minOccupation: number
  energyReserved: number
  currentCapacity: number
  maxCapacity: number
  image: ImageObject
  translations: Translations
  addresses: Address[]
  order: number
}

export type CapacityState = {
  soldOut: boolean
  almostSoldOut: boolean
  usedEnergy: number
}

export type Image = {
  url?: string
  name?: string
}

export type ImageObject = {
  header?: Image
  profile?: Image
  extra?: Image[]
}

export type Location = {
  lat: number
  lng: number
}

export type Producer = {
  id: string
  salesforceId: string
  name: {
    nl: string
    fr: string
  }
  slug: string
  location: string
  image: string
  header: string
  description: {
    nl: string
    fr: string
  }
  longDescription: {
    nl: string
    fr: string
  }
  energyType: EnergyType
  energySourceRegion: string
  positions: Location[]
  energyUsed: number
  energyReserved: number
  facts: {
    nl: string[]
    fr: string[]
  }
  dateAdded: string
  isFeatured: {
    nl: boolean
    fr: boolean
  }
  isPopular: {
    nl: boolean
    fr: boolean
  }
  translations: any
  maxCapacity: number
  minOccupation: number
  usedCapacity: number
  isSoldOut: boolean
  state: State
  order: number
  capacityState?: {
    soldOut: boolean
  }
}

type Translations = {
  [key: string]: {
    slug: string
    name: string
    description: string
    longDescription: string
    facts: string[]
  }
}
